import React from 'react';

import { Chip, Tooltip } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import processing_activities_messages from 'messages/processing_activities_messages';

const DpiaAvailableIndicator: React.FC<{ available?: boolean }> = ({ available }) => {
  const { t } = useTranslation();
  if (!available) return null;
  const messages = processing_activities_messages.asset_ropa;
  return (
    <Tooltip title={t(messages.dpia_available_tooltip)}>
      <Chip label={t(messages.dpia_available)} size='small' style={{ marginLeft: 8 }} variant='outlined' />
    </Tooltip>
  );
};

export default DpiaAvailableIndicator;
